























import {Component, Prop, Watch} from 'vue-property-decorator';
import BaseComponent from '@/core/components/BaseComponent';
import {Client} from "@/core/services/MedicaPro/models";
import ClientDetailsPageHeaderView
    from "@/components/Admin/Clients/Details/Components/ClientDetailsPage-HeaderView.vue";
import {Api} from "@/core/services/MedicaPro/Api";
import ClientMeasurementList
    from "@/components/Admin/Clients/Details/Components/ClientDashboard/Components/ClientMeasurementList.vue";

@Component({
    components: {
        ClientMeasurementList,
        ClientDetailsPageHeaderView

    }
})
export default class ClientDashboard extends BaseComponent {

    // Bindings to parent
    @Prop() item!: Client;

    // Bindings to view
    public isReady = false;

    public mounted() {
        this.renderView();
    }

    public beforeDestroy() {
        super.beforeDestroy();
    }

    private renderView() {
        this.isReady = true;
    }

    public onNoteChanged() {
        Api.clients().patchById(this.item.id!)
            .save({note: this.item.note ?? ''} as any);
    }

}
